import React from 'react';
import { errorState } from '../utils/designTokens';

/**
 * ErrorState - Displays page load error messages
 *
 * NOTE: This is for page load failures (network errors, API failures),
 * NOT for the "Error Rate" KPI pill metric.
 *
 * @param {string} title - Error heading (e.g., "Error Loading Agents")
 * @param {string} message - Error details from error.message
 */
const ErrorState = ({ title, message }) => {
  if (!title) throw new Error('ErrorState requires title prop');
  if (!message) throw new Error('ErrorState requires message prop');

  return (
    <div className={errorState.wrapper}>
      <div className={errorState.container}>
        <h3 className={errorState.title}>{title}</h3>
        <p className={errorState.message}>{message}</p>
      </div>
    </div>
  );
};

export default ErrorState;
